import { Trans } from 'react-i18next';
import {
  Anchor,
  Box,
  Checkbox,
  DefaultProps,
  MantineTheme,
} from '@mantine/core';

import { STATIC_URLS } from 'consts';

import { AgreementsType } from './types';

type Props = {
  agreements: AgreementsType;
  onAgreementsChange: (
    agreements: AgreementsType,
    sourceChanged: keyof AgreementsType | 'all',
  ) => void;
  errors: {
    [key in keyof AgreementsType]?: string;
  };
  sx?: DefaultProps['sx'];
};

export const Agreements = ({
  agreements,
  onAgreementsChange,
  errors: { terms: termsError = '' },
  sx,
}: Props) => {
  const changeAgreement = (checked: boolean, field: keyof AgreementsType) => {
    onAgreementsChange(
      {
        ...agreements,
        [field]: checked,
      },
      field,
    );
  };

  const checkboxSx = (theme: MantineTheme) => ({
    label: {
      fontSize: theme.fontSizes.md,
    },
  });

  return (
    <Box sx={sx}>
      <Checkbox
        sx={checkboxSx}
        label={
          <>
            *{' '}
            <Trans
              i18nKey="user:acceptTerms"
              components={{
                a: (
                  <Anchor
                    href={STATIC_URLS.termsAndConditions}
                    target="_blank"
                  />
                ),
              }}
            />
          </>
        }
        checked={agreements.terms}
        onChange={e => {
          changeAgreement(e.target.checked, 'terms');
        }}
        error={termsError}
      />
    </Box>
  );
};
